import { render, staticRenderFns } from "./InviteConsultantForm.vue?vue&type=template&id=34be3e66&"
import script from "./InviteConsultantForm.vue?vue&type=script&setup=true&lang=ts&"
export * from "./InviteConsultantForm.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports